import { ReactNode } from 'react';

import { Typography, TypographyProps } from '@mui/material';

import clsx from 'clsx';

import { Icon, noteClasses, Root } from './styles';

interface Props {
  icon?: JSX.Element;
  color?: 'success' | 'error' | 'warning' | 'info';
  /** @default 'paragraphRegular' */
  variant?: TypographyProps['variant'];
  children: ReactNode;
  className?: string;
  classes?: Partial<typeof noteClasses>;
}

const Note = ({ icon, color, variant = 'paragraphRegular', children, className, classes }: Props) => {
  return (
    <Root
      className={clsx(
        noteClasses.root,
        className,
        classes?.root,
        {
          [noteClasses.colorSuccess]: color === 'success',
          [noteClasses.colorError]: color === 'error',
          [noteClasses.colorWarning]: color === 'warning',
          [noteClasses.colorInfo]: color === 'info',
        },
        classes?.colorSuccess && { [classes.colorSuccess]: color === 'success' },
        classes?.colorError && { [classes.colorError]: color === 'error' },
        classes?.colorWarning && { [classes.colorWarning]: color === 'warning' },
        classes?.colorInfo && { [classes.colorInfo]: color === 'info' }
      )}
    >
      <Icon className={clsx(noteClasses.icon, classes?.icon)}>{icon}</Icon>
      {typeof children === 'string' ? (
        <Typography variant={variant} className={clsx(noteClasses.text, classes?.text)}>
          {children}
        </Typography>
      ) : (
        children
      )}
    </Root>
  );
};

export default Note;
